import React from "react";
import { useDispatch } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import {
  fetch_consultationInititalisation,
  screenstatusupdate,
  finishconsultation,
  fetch_consultationDetails,
} from "../../actions/RPMAction";

import "./Land.scss";
import VideoConsultation from "./components/commonVideoConsultation/VideoConsultation";

const ConsultationLanding = ({ userRole = "Web_Doctor" }) => {
  // const [userrole,setUserrole]=React.useState(userRole)
  const { appointmentId } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const [zoomConfig, setZoomConfig] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [headerData, setHeaderData] = React.useState(null);

  // Get user data
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const role = userRole || userData.userType || "Web_Patient";
  console.log(userData, "👤 User Data Retrieved");
  // setUserrole(role)

  React.useEffect(() => {
    const fetchUserData = async () => {
      console.log(appointmentId, `🔍 Fetching consultation for ${role}`);
      if (!appointmentId) {
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        setError(null);

        // Dispatch screen status update when joining consultation
        if (role === "Web_Doctor") {
          await dispatch(
            screenstatusupdate(
              "Doctor",
              appointmentId,
              "In Consultation Screen"
            )
          );
          console.info("📊 Screen status updated to 'In Consultation Screen'");
        }

        let roleforUrl = role === "Web_Doctor" ? "Doctor" : "Patient";
        let response = await dispatch(
          fetch_consultationInititalisation(appointmentId, roleforUrl)
        );

        if (response) {
          const sessionData = response;
          const config = {
            sessionName:
              sessionData.sessionId ||
              sessionData.sessionName ||
              sessionData.tokenid,
            sessionToken: sessionData.tokenId || sessionData.token,
            userName: role,
          };
          console.log(config, "⚙️ Zoom Configuration Set");
          setZoomConfig(config);
          // setHeaderData(response);
        }
        let headerresponse = await dispatch(
          fetch_consultationDetails(appointmentId, roleforUrl)
        );

        if (headerresponse) {        
          setHeaderData(headerresponse);
        }
        else {
          setHeaderData(null);
        }
      } catch (dispatchError) {
        console.error("❌ Dispatch failed:", dispatchError);
        setError("Failed to initialize consultation");
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, [appointmentId, dispatch, role]);

  const handleSessionEnd = async (sessionData = {},isEndByDuplicate=false) => {
    console.log("session is ending... by duplicate issue ? :", isEndByDuplicate);

    // For doctors, execute finish consultation logic similar to ZoomDoctorUI
    if (role === "Web_Doctor" && !isEndByDuplicate) {
      console.log("isendbyduplicate value in handleSessionEnd:", isEndByDuplicate);
      try {
        const requestData = {
          attachementArrs: [],
          consultationId: appointmentId,
          visitId: localStorage.getItem("visitId"),
          isvalid: "No",
          userType: role,
          prescriptionfrom: "RPM",
          consultationDetails: {
            doctor_suggestion: sessionData.doctorSuggestion || "",
            chiefcomplaints: sessionData.chiefComplaints || "",
            diagnosis: sessionData.diagnosis || "",
            investigation: sessionData.investigation || "",
            notes: sessionData.notes || "",
            instruction: sessionData.instruction || "",
            share: true,
            medicine: sessionData.medicine || [],
            labTest: sessionData.labTest || [],
            nextStep: sessionData.nextStep || {},
            privateMessage: sessionData.privateMessage || "",
            height: sessionData.height || "",
            weight: sessionData.weight || "",
            lmp: sessionData.lmp || "",
          },
        };

        console.log("📋 Sending finish consultation data:", requestData);

        const result = await dispatch(finishconsultation(requestData));

        if (result.info !== "Data failed to update") {
           if(role === "Web_Doctor" ){
                  history.push({
                pathname: "/dashboard",
                state: { appointmentId: appointmentId, page: "prescripton", consultationData: result, },
              });
          }else
          {
            history.push({
            pathname: "/dashboard",
            state: {
              appointmentId: appointmentId,
           },
          });
          }
       
        } else {
          console.error("❌ Failed to finish consultation");
          // Still redirect but show error message
          history.push({
            pathname: "/dashboard",
            state: {
              appointmentId: appointmentId,
              page: "prescription",
              error: "Failed to save consultation data",
            },
          });
        }
      } catch (error) {
        console.error("❌ Error finishing consultation:", error);
        // Redirect even if there's an error
        history.push({
          pathname: "/dashboard",
          state: {
            appointmentId: appointmentId,
            error: "Error saving consultation data",
          },
        });
      }
    } else {
      // For patients, simply redirect to dashboard
      history.push({
        pathname: "/dashboard",
        state: { appointmentId: appointmentId },
      });
    }
  };

  const handleSessionJoin = async () => {
    console.log("🔗 Session joined");

    if (role === "Web_Doctor") {
      try {
        await dispatch(
          screenstatusupdate("Doctor", appointmentId, "In Consultation Screen")
        );
        console.info("📊 Screen status confirmed - Session fully joined");
      } catch (error) {
        console.warn("⚠️ Failed to update screen status on join:", error);
      }
    }
  };

  const handleRetry = () => {
    setError(null);
    setIsLoading(true);
    setZoomConfig(null);

    setTimeout(() => {
      const fetchUserData = async () => {
        try {
          let response = await dispatch(
            fetch_consultationInititalisation(appointmentId, role)
          );

          if (response) {
            const sessionData = response;
            const config = {
              sessionName:
                sessionData.sessionId ||
                sessionData.sessionName ||
                sessionData.tokenid,
              sessionToken: sessionData.tokenId || sessionData.token,
              userName: role,
            };
            setZoomConfig(config);
          }
        } catch (error) {
          setError("Failed to initialize consultation. Please try again.");
        } finally {
          setIsLoading(false);
        }
      };

      fetchUserData();
    }, 1000);
  };

  // Loading, error, and invalid appointment states remain the same...
  if (isLoading) {
    return (
      <div className="zoom-full-height">
        <div className="loading-state">
          <div className="loading-content">
            <div className="spinner"></div>
            <p className="loading-text">Initializing consultation...</p>
            <p className="loading-subtext">Setting up your video session</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="zoom-full-height">
        <div className="error-state">
          <div className="error-content">
            <div className="error-icon">❌</div>
            <h3 className="error-title">Connection Error</h3>
            <p className="error-message">{error}</p>
            <div className="error-actions">
              <button onClick={handleRetry} className="retry-button">
                Retry
              </button>
              <button
                onClick={() => history.push("/dashboard")}
                className="dashboard-button"
              >
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!appointmentId) {
    return (
      <div className="zoom-full-height">
        <div className="invalid-appointment">
          <div className="invalid-content">
            <div className="invalid-icon">❌</div>
            <h3 className="invalid-title">Invalid Appointment</h3>
            <p className="invalid-message">
              No appointment ID found in the URL
            </p>
            <button
              onClick={() => history.push("/dashboard")}
              className="dashboard-button"
            >
              Go to Dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="zoom-full-height">
      {zoomConfig ? (
        <VideoConsultation
          config={zoomConfig}
          role={role}
          headerData={headerData}
          onLeave={handleSessionEnd}
          onJoin={handleSessionJoin}
        />
      ) : (
        <div className="not-ready-state">
          <div className="not-ready-content">
            <div className="warning-icon">⚠️</div>
            <h3 className="not-ready-title">Consultation Not Ready</h3>
            <p className="not-ready-message">
              The consultation session is not available at the moment.
            </p>
            <div className="not-ready-actions">
              <button onClick={handleRetry} className="retry-button">
                Try Again
              </button>
              <button
                onClick={() => history.push("/dashboard")}
                className="dashboard-button"
              >
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export const DoctorConsultation = () => {
  return <ConsultationLanding userRole="Web_Doctor" />;
};

export const PatientConsultation = () => {
  return (
    <>
      <ConsultationLanding userRole="Web_Patient" />
    </>
  );
};
export const SpokeConsultation = () => {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const profileName = userData?.profileName || "";
  console.log(userData, "👤 User Data Retrieved");
  return (
    <>
      <ConsultationLanding userRole={`Spoke-${profileName}`} />
    </>
  );
};
